export const pages = {
	'pop': { id: 'pop', page: 'main', getter: () => import(/* webpackChunkName: 'main' */ 'components/bolt/main/main') },
	'popAR': { id: 'popAR', page: 'arIntro', getter: () => import(/* webpackChunkName: 'arIntro' */ 'components/bolt/arIntro/arIntro') },
	'sciFi': { id: 'sciFi', page: 'main', getter: () => import(/* webpackChunkName: 'main' */ 'components/bolt/main/main') },
	'portals': { id: 'portals', page: 'portals', getter: () => import(/* webpackChunkName: 'portals' */ 'components/bolt/portals/portals') },
	'sciFiAR': { id: 'sciFiAR', page: 'arIntro', getter: () => import(/* webpackChunkName: 'arIntro' */ 'components/bolt/arIntro/arIntro') },
	'sliceOfLife': { id: 'sliceOfLife', page: 'main', getter: () => import(/* webpackChunkName: 'main' */ 'components/bolt/main/main') },
	'sliceOfLifeAR': { id: 'sliceOfLifeAR', page: 'arIntro', getter: () => import(/* webpackChunkName: 'arIntro' */ 'components/bolt/arIntro/arIntro') }
};
export const sections = [

];
export const sectionsWithParent = [

];
